import React from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

export default function ContributorEditModal({
  isOpen,
  toggle,
  contributor,
  errors,
  isSaving,
  onSubmit,
}) {
  if (!contributor) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>
        Edit contributor · {contributor.contributor_name}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label for="bank_account_number">Bank account number</Label>
                <Input
                  id="bank_account_number"
                  name="bank_account_number"
                  defaultValue={contributor.bank_account_number || ""}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="bank_iban_number">IBAN</Label>
                <Input
                  id="bank_iban_number"
                  name="bank_iban_number"
                  defaultValue={contributor.bank_iban_number || ""}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label for="bank_swift_number">SWIFT / BIC</Label>
                <Input
                  id="bank_swift_number"
                  name="bank_swift_number"
                  defaultValue={contributor.bank_swift_number || ""}
                  required
                />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="bank_name">Bank name</Label>
                <Input
                  id="bank_name"
                  name="bank_name"
                  defaultValue={contributor.bank_name || ""}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label for="ca_ipi">CA IPI</Label>
                <Input id="ca_ipi" name="ca_ipi" defaultValue={contributor.ca_ipi || ""} />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="currency">Currency</Label>
                <Input
                  id="currency"
                  name="currency"
                  defaultValue={contributor.currency || ""}
                  invalid={!!errors?.currency}
                  required
                />
                {errors?.currency ? (
                  <FormFeedback>{errors.currency[0]}</FormFeedback>
                ) : null}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit" disabled={isSaving}>
            {isSaving ? "Saving…" : "Save changes"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
}
